export const baseUrl =
  window.location.hostname === "localhost"
    ? "https://energiareal.ui.ceelabs.com"
    : window.location.origin;

export const sensors = [
  {
    id: "T103",
    name: "T103",
    path: "/TemperatureSensor/T103",
    type: "temperature",
    description: "Teplota vychladenej kanalizačnej vody na výstupe z objektu"
  },
  {
    id: "T104",
    name: "T104",
    path: "/TemperatureSensor/T104",
    type: "temperature",
    description: "Teplota privádzanej kanalizačnej vody"
  },
  {
    id: "T411",
    name: "T411",
    path: "/TemperatureSensor/T411",
    type: "temperature",
    description: "Teplota teplej vody dodávanej do objektu"
  },
  {
    id: "T600",
    name: "T600",
    path: "/TemperatureSensor/T600",
    type: "temperature",
    description: "Teplota vonkajšieho prostredia"
  },
  {
    id: "T609",
    name: "T609",
    path: "/TemperatureSensor/T609",
    type: "temperature",
    description: "Priemerná teplota vzduchu v objekte"
  },
  {
    id: "MEL",
    name: "MEL",
    path: "/EnergyMeter/MEL",
    type: "energy",
    description: "Elektrina spotrebovaná na cirkuláciu tepla v objekte"
  },
  {
    id: "M31",
    name: "M31",
    path: "/EnergyMeter/M31",
    type: "energy",
    description: "Teplo dodané z odpadu na vykurovanie objektu"
  },
  {
    id: "M32",
    name: "M32",
    path: "/EnergyMeter/M32",
    type: "energy",
    description: "Teplo dodané z odpadu na výrobu teplej vody"
  },
  {
    id: "M42",
    name: "M42",
    path: "/WaterMeter/M42",
    type: "water",
    description: "Teplá voda dodávaná teplárenskou spoločnosťou"
  },
  {
    id: "M41",
    name: "M41",
    path: "/WaterMeter/M41",
    type: "water",
    description: "Pitná voda spotrebovaná na prípravu teplej vody"
  },  
  {
    id: "M51",
    name: "M51",
    path: "/EnergyMeter/M51",
    type: "energy",
    description: "Teplo dodané od dodávateľa tepla na vykurovanie"
  },  
];
